import { Divider, Grid, Typography } from '@mui/material';
import { useCaseStore } from '../../../../../../../store/hooks';
import { Text } from '../../../Description.styled';
import { Input } from '../../../../../../shared/ui/form/input/Input';
import { getDate } from '../../../../../../../utils/dateSort';
import { CheckedIconContainer } from '../../../checkedIcon/CheckedIcon';
import { observer } from 'mobx-react-lite';
import { IThirdStageValuesCushingV2 } from '../../../../../user/caseDraft/stages/cushing-v2/thirdStage/ThirdStage.types';
import { dateStringify } from '../../../../../../../utils/dateStringify';
import CortisolChart from './chart/CortisolChart';
import { checkEmptyNumber } from '../../../../../user/caseDraft/CaseDraft.helper';

export const ThirdStage = observer(() => {
  const caseStore = useCaseStore();

  const { thirdStage } = caseStore as { thirdStage: IThirdStageValuesCushingV2 };

  // const treatmentBeforeOperationSteroidogenesisInhibitorSection =
  //   thirdStage.treatmentBeforeOperationInhibitors?.length > 0;

  // const treatmentBeforeOperationPasireotidesSection =
  //   thirdStage?.treatmentBeforeOperationPasireotides?.length > 0;

  // const treatmentBeforeOperationCabergolinesSection =
  //   thirdStage?.treatmentBeforeOperationCabergolines?.length > 0;

  // const preparationSection =
  //   treatmentBeforeOperationSteroidogenesisInhibitorSection ||
  //   treatmentBeforeOperationPasireotidesSection ||
  //   treatmentBeforeOperationCabergolinesSection;

  //   const hypercortisolaemiaPasireotidesSection = thirdStageStageCushing.hypercortisolaemiaPasireotides.length > 0;

  //   const hypercortisolaemiaCabergolinesSection = thirdStageStageCushing.hypercortisolaemiaCabergolines.length > 0;

  //   const pharmacologicalTreatmentSection =
  //     hypercortisolaemiaPasireotidesSection ||
  //     hypercortisolaemiaCabergolinesSection ||
  //     Boolean(thirdStageStageCushing.steroidogenesisInhibitorHow);

  //   const qualificationsSection =
  //     Boolean(thirdStageStageCushing.qualificationsDiagnosisAccess) ||
  //     Boolean(thirdStageStageCushing.qualificationsDiagnosisAccess) ||
  //     thirdStageStageCushing.qualificationsDiagnosis.length > 0;

  //   const biochemicalNormalizationYesSection = thirdStageStageCushing.biochemicalNormalization === 'Tak';

  //   const anotherComplicationsSection =
  //     thirdStageStageCushing.anotherComplications?.length > 0 ||
  //     Boolean(thirdStageStageCushing.anotherComplicationsAnother);

  //   const titleSection =
  //     treatmentBeforeOperationSteroidogenesisInhibitorSection ||
  //     treatmentBeforeOperationPasireotidesSection ||
  //     treatmentBeforeOperationCabergolinesSection ||
  //     preparationSection ||
  //     hypercortisolaemiaPasireotidesSection ||
  //     hypercortisolaemiaCabergolinesSection ||
  //     pharmacologicalTreatmentSection ||
  //     qualificationsSection ||
  //     biochemicalNormalizationYesSection ||
  //     anotherComplicationsSection ||
  //     thirdStageStageCushing.treatmentOfChoivePatient.length > 0 ||
  //     thirdStageStageCushing.operations.length > 0 ||
  //     thirdStageStageCushing.subnormalCortisolLevels ||
  //     thirdStageStageCushing.hydrocortisolTreatment ||
  //     thirdStageStageCushing.complicationsOfSurgicalProcedures ||
  //     thirdStageStageCushing.biochemicalNormalization ||
  //     thirdStageStageCushing.toleranceOfPharmacologicalTreatment.length > 0 ||
  //     thirdStageStageCushing.supprotiveTreatment.length > 0 ||
  //     thirdStageStageCushing.improvementControl.length > 0 ||
  //     thirdStageStageCushing.complicationsOfSurgicalProceduresCheck.length > 0;

  if (!thirdStage) {
    return null;
  }

  return (
    <Grid container justifyContent={'space-between'} width={'100%'}>
      <Typography variant={'h5'}>Leczenie zespołu cushinga</Typography>
      {thirdStage.treatmentOfChoivePatient.length > 0 && (
        <Grid container display={'flex'} alignItems={'center'}>
          <Grid item xs={12} mt={2} mb={2}>
            <Typography variant={'h6'}>Leczenie z wyboru, które zastosowano u pacjenta:</Typography>
          </Grid>
          {thirdStage.treatmentOfChoivePatient.map((treatment, index) => (
            <Grid container key={index + treatment.treatment} display={'flex'} alignItems={'center'}>
              <Grid
                item
                pr={2}
                alignItems={'center'}
                justifyContent={'center'}
                display="flex"
                flexDirection={'column'}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="35" viewBox="0 0 12 35" fill="none">
                  <circle cx="6" cy="17.5" r="6" fill="#BDBDBD" />
                </svg>
              </Grid>
              <Grid item gap={1} justifyContent={'center'} display="flex" flexDirection={'column'}>
                <Typography variant={'body1'} lineHeight={'24px'}>
                  {getDate(treatment.date && dateStringify(treatment.date, false))}
                </Typography>
              </Grid>
              <Grid item xs={12} pl={'22px'} py={0.5} ml={'6px'} style={{ borderLeft: '1px solid #BDBDBD' }}>
                <Typography style={{ wordBreak: 'break-word' }} variant={'body1'} color={'rgba(0, 0, 0, 0.60)'}>
                  {treatment.treatment}
                </Typography>
              </Grid>
            </Grid>
          ))}
        </Grid>
      )}
      {thirdStage.treatmentBeforeOperationInhibitorsCheckbox && (
        <Grid container display={'flex'} alignItems={'center'}>
          <Grid item xs={12} mt={2}>
            <Typography variant={'h6'}>Leczenie przygotowawcze przed zabiegiem operacyjnym (jeśli dotyczy):</Typography>
          </Grid>
          <Grid alignSelf={'stretch'} display={'flex'} alignItems={'center'}>
            <CheckedIconContainer />
            <Text>inhibitor steroidogenezy</Text>
          </Grid>
          <Grid item xs={12}>
            {thirdStage.treatmentBeforeOperationInhibitors?.length > 0 &&
              thirdStage.treatmentBeforeOperationInhibitors.map((treatment, index) => (
                <Grid container key={index} display={'flex'} alignItems={'center'}>
                  <Grid
                    item
                    pr={2}
                    alignItems={'center'}
                    justifyContent={'center'}
                    display="flex"
                    flexDirection={'column'}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="35" viewBox="0 0 12 35" fill="none">
                      <circle cx="6" cy="17.5" r="6" fill="#BDBDBD" />
                    </svg>
                  </Grid>
                  <Grid item gap={1} justifyContent={'center'} display="flex" flexDirection={'column'}>
                    <Typography variant={'body1'} lineHeight={'24px'} pt={0.5}>
                      {getDate(treatment.dateStart && dateStringify(treatment.dateStart, false))} -{' '}
                      {getDate(treatment.dateEnd && dateStringify(treatment.dateEnd, false))}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} pl={'22px'} py={0.5} ml={'6px'} style={{ borderLeft: '1px solid #BDBDBD' }}>
                    <Typography style={{ wordBreak: 'break-word' }} variant={'caption'} color={'rgba(0, 0, 0, 0.60)'}>
                      {getDate(treatment.type)}
                    </Typography>
                    <Typography style={{ wordBreak: 'break-word' }} variant={'body1'} mt={1} color={'rgba(0, 0, 0, 0.60)'}>
                      Dawka {treatment.dose}
                    </Typography>
                  </Grid>
                </Grid>
              ))}
          </Grid>
        </Grid>
      )}
      {thirdStage.operations.length > 0 && (
        <Grid container display={'flex'} alignItems={'center'} mt={2}>
          <Grid item xs={12} mt={2} mb={2}>
            <Typography variant={'h6'}>Zabiegi operacyjne:</Typography>
          </Grid>

          {thirdStage.operations?.map((operation, index) => (
            <Grid container key={index} display={'flex'} alignItems={'center'}>
              <Grid
                item
                pr={2}
                alignItems={'center'}
                justifyContent={'center'}
                display="flex"
                flexDirection={'column'}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="35" viewBox="0 0 12 35" fill="none">
                  <circle cx="6" cy="17.5" r="6" fill="#BDBDBD" />
                </svg>
              </Grid>
              <Grid item gap={1} justifyContent={'center'} display="flex" flexDirection={'column'}>
                <Typography variant={'body1'} lineHeight={'24px'} pt={0.5}>
                  {getDate(operation.date && dateStringify(operation.date, false))}
                </Typography>
              </Grid>
              <Grid item xs={12} pl={'22px'} py={0.5} ml={'6px'} style={{ borderLeft: '1px solid #BDBDBD' }}>
                <Typography style={{ wordBreak: 'break-word' }} variant={'caption'} color={'rgba(0, 0, 0, 0.60)'}>
                  {operation.type}
                </Typography>
                <Typography style={{ wordBreak: 'break-word' }} variant={'body1'} mt={1} color={'rgba(0, 0, 0, 0.60)'}>
                  {operation.pituaryTumor}
                </Typography>
              </Grid>
            </Grid>
          ))}
        </Grid>
      )}
      {thirdStage.subnormalCortisolLevels && (
        <Grid container display={'flex'} alignItems={'center'} mt={2}>
          <Grid item xs={12}>
            <Typography variant={'h6'}>
              Subnormalne stężenie kortyzolu w surowicy w okresie bezpośrednio po operacji (&lt; 2,0 μg/dl):
            </Typography>
          </Grid>
          <Grid item xs={12} display={'flex'} alignItems={'center'} justifyItems={'center'} mt={2}>
            <CheckedIconContainer />
            <Text>{thirdStage.subnormalCortisolLevels}</Text>
          </Grid>
        </Grid>
      )}
      {thirdStage.hydrocortisolTreatment && (
        <Grid container display={'flex'} alignItems={'center'} mt={2}>
          <Grid item xs={12}>
            <Typography variant={'h6'}>Konieczność leczenia substytucyjnego hydrokortyzonem:</Typography>
          </Grid>
          <Grid item xs={2} display={'flex'} alignItems={'center'} justifyItems={'center'} mt={2}>
            <CheckedIconContainer />
            <Text>{thirdStage.hydrocortisolTreatment}</Text>
          </Grid>
          {thirdStage.hydrocortisolTreatment === 'Tak' && (
            <>
              <Grid item xs={3} pr={2}>
                <Input
                  multiline
                  disabled
                  variant={'standard'}
                  fullWidth={true}
                  name={'hydrocortisolTreatmentDateStart'}
                  label={'OD'}
                  type={'text'}
                  value={getDate(
                    thirdStage.hydrocortisolTreatmentDateStart &&
                    dateStringify(thirdStage.hydrocortisolTreatmentDateStart, false)
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                <Input
                  multiline
                  disabled
                  variant={'standard'}
                  fullWidth={true}
                  name={'hydrocortisolTreatmentDateEnd'}
                  label={'DO'}
                  type={'text'}
                  value={getDate(
                    thirdStage.hydrocortisolTreatmentDateEnd &&
                    dateStringify(thirdStage.hydrocortisolTreatmentDateEnd, false)
                  )}
                />
              </Grid>
            </>
          )}
        </Grid>
      )}
      {(thirdStage.complicationsOfSurgicalProcedures ||
        thirdStage.complicationsOfSurgicalProceduresCheck?.length > 0) && (
          <Grid container display={'flex'} alignItems={'center'} mt={2}>
            {thirdStage.complicationsOfSurgicalProcedures && (
              <>
                <Grid item xs={12}>
                  <Typography variant={'h6'}>
                    Powikłania zabiegów operacyjnych (neurochirurgicznych w przypadku ch. Cushinga):
                  </Typography>
                </Grid>
                <Grid item xs={3} pl={2} mt={2}>
                  <Text>Moczówka prosta</Text>
                </Grid>
                <Grid item xs={4} display={'flex'} alignItems={'center'} justifyItems={'center'} mt={2}>
                  <CheckedIconContainer />
                  <Text>{thirdStage.complicationsOfSurgicalProcedures}</Text>
                </Grid>
              </>
            )}

            {thirdStage.complicationsOfSurgicalProceduresCheck.map(procedure => (
              <Grid item xs={12} key={procedure} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                <CheckedIconContainer />
                <Text>{procedure}</Text>
              </Grid>
            ))}
          </Grid>
        )}

      {(thirdStage.pasireotideLar4WeeksCheckbox ||
        thirdStage.cabergolineCheckbox ||
        thirdStage.steroidogenesisInhibitorCheckbox) && (
          <Grid container display={'flex'} alignItems={'center'} mt={2}>
            <Grid item xs={12} mb={2}>
              <Typography variant={'h6'}>Przetrwała hiperkortyzolemia:</Typography>
            </Grid>
            {thirdStage.pasireotideLar4WeeksCheckbox && (
              <>
                <Grid item xs={12} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                  <CheckedIconContainer />
                  <Text>pazyreotyd LAR co 4 tygodnie</Text>
                </Grid>
                <Grid container display={'flex'} alignItems={'flex-start'}>
                  <Grid item xs={2.5} pr={2} alignSelf={'stretch'}>
                    <Input
                      disabled
                      variant={'standard'}
                      fullWidth={true}
                      name={'pasireotideLar4WeeksDose'}
                      label={'Dawka (mg)'}
                      type={'text'}
                      value={thirdStage.pasireotideLar4WeeksDose}
                    />
                  </Grid>
                  <Grid item xs={2.5} pr={2} alignSelf={'stretch'}>
                    <Input
                      multiline
                      disabled
                      variant={'standard'}
                      fullWidth={true}
                      name={'pasireotideLar4WeeksDateStart'}
                      label={'stosowanie - OD'}
                      type={'text'}
                      value={dateStringify(thirdStage.pasireotideLar4WeeksDateStart, false)}
                    />
                  </Grid>
                  <Grid item xs={2.5} alignSelf={'stretch'}>
                    <Input
                      multiline
                      disabled
                      variant={'standard'}
                      fullWidth={true}
                      name={'pasireotideLar4WeeksDateEnd'}
                      label={'stosowanie - DO'}
                      type={'text'}
                      value={dateStringify(thirdStage.pasireotideLar4WeeksDateEnd, false)}
                    />
                  </Grid>
                </Grid>
              </>
            )}

            {thirdStage.pasireotideLar4WeeksBiochemicalNormalization && (
              <Grid container display={'flex'} alignItems={'center'} mt={2}>
                <Grid item xs={12}>
                  <Typography variant={'subtitle1'}>Uzyskano normalizację biochemiczną:</Typography>
                </Grid>
                <Grid item xs={12} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                  <CheckedIconContainer />
                  <Text>{thirdStage.pasireotideLar4WeeksBiochemicalNormalization}</Text>
                </Grid>
              </Grid>
            )}
            {thirdStage.pasireotideLar4WeeksCortisolDzmisActive && (
              <Grid container>
                <Grid item xs={5} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                  <CheckedIconContainer />
                  <Text>wolnego kortyzolu w DZM</Text>
                </Grid>
                {thirdStage.pasireotideLar4WeeksCortisolDzm && (
                  <Grid item xs={2.5} alignSelf={'stretch'}>
                    <Input
                      multiline
                      disabled
                      variant={'standard'}
                      fullWidth={true}
                      name={'pasireotideLar4WeeksCortisolDzm'}
                      label={'okres - OD'}
                      type={'text'}
                      value={dateStringify(thirdStage.pasireotideLar4WeeksCortisolDzm, false)}
                    />
                  </Grid>
                )}
              </Grid>
            )}
            {thirdStage.pasireotideLar4WeeksCortisolSalivaisActive && (
              <Grid container>
                <Grid item xs={5} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                  <CheckedIconContainer />
                  <Text>wolnego kortyzolu w ślinie</Text>
                </Grid>
                {thirdStage.pasireotideLar4WeeksCortisolSaliva && (
                  <Grid item xs={2.5} alignSelf={'stretch'}>
                    <Input
                      multiline
                      disabled
                      variant={'standard'}
                      fullWidth={true}
                      name={'pasireotideLar4WeeksCortisolSaliva'}
                      label={'okres - OD'}
                      type={'text'}
                      value={dateStringify(thirdStage.pasireotideLar4WeeksCortisolSaliva, false)}
                    />
                  </Grid>
                )}
              </Grid>
            )}
            {thirdStage.pasireotideLar4WeeksCortisolSerumisActive && (
              <Grid container>
                <Grid item xs={5} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                  <CheckedIconContainer />
                  <Text>wolnego kortyzolu w surowicy</Text>
                </Grid>
                {thirdStage.pasireotideLar4WeeksCortisolSerum && (
                  <Grid item xs={2.5} alignSelf={'stretch'}>
                    <Input
                      multiline
                      disabled
                      variant={'standard'}
                      fullWidth={true}
                      name={'pasireotideLar4WeeksCortisolSerum'}
                      label={'okres - OD'}
                      type={'text'}
                      value={dateStringify(thirdStage.pasireotideLar4WeeksCortisolSerum, false)}
                    />
                  </Grid>
                )}
              </Grid>
            )}

            {thirdStage.pasireotideLar4WeeksToleranceOfPharmacologicalTreatment.length > 0 && (
              <Grid container display={'flex'} alignItems={'center'} mt={2}>
                <Grid item xs={12} mb={2}>
                  <Typography variant={'h6'}>Tolerancja stosowanego leczenia farmakologicznego:</Typography>
                </Grid>
                {thirdStage.pasireotideLar4WeeksToleranceOfPharmacologicalTreatment.map(treatment => (
                  <Grid item key={treatment} xs={12} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                    <CheckedIconContainer />
                    <Text>{treatment}</Text>
                  </Grid>
                ))}
              </Grid>
            )}
            {thirdStage.pasireotideLar4WeeksAnotherComplications &&
              thirdStage.pasireotideLar4WeeksAnotherComplications.length > 0 && (
                <Grid container display={'flex'} alignItems={'center'} mt={2} mb={2}>
                  <Grid item xs={12} mb={2}>
                    <Typography variant={'h6'}>Inne powikłania:</Typography>
                  </Grid>
                  {thirdStage.pasireotideLar4WeeksAnotherComplications.map(treatment => (
                      <Grid item key={treatment} xs={12} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                        <CheckedIconContainer />
                        <Text>{treatment}</Text>
                      </Grid>
                  ))}

                </Grid>
              )}
            {thirdStage.pasireotideLar4WeeksReasonStopTreatment && (
              <>
                <Grid item xs={3} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                  <CheckedIconContainer />
                  <Text>inne (jakie?)</Text>
                </Grid>
                <Grid item xs={9}>
                  <Input
                    multiline
                    disabled
                    variant={'standard'}
                    fullWidth={true}
                    name={'pasireotideLar4WeeksReasonStopTreatment'}
                    label={'inne (jakie?)'}
                    type={'text'}
                    value={thirdStage.pasireotideLar4WeeksAnotherComplicationsAnother}
                  />
                </Grid>
              </>
            )}
            {thirdStage.pasireotideLar4WeeksReasonStopTreatment && (
              <Grid item xs={12} mt={2}>
                <Input
                  multiline
                  disabled
                  variant={'standard'}
                  fullWidth={true}
                  name={'pasireotideLar4WeeksReasonStopTreatment'}
                  label={'Powód przerwania leczenia (jeśli dotyczy)'}
                  type={'text'}
                  value={thirdStage.pasireotideLar4WeeksReasonStopTreatment}
                />
              </Grid>
            )}
            <Grid item xs={12} mb={4} mt={2}>
              <Divider sx={{ width: '100%' }} />
            </Grid>
          </Grid>
        )}

      <>
        {thirdStage.cabergolineCheckbox && (
          <Grid container>
            <Grid item xs={12} display={'flex'} alignItems={'center'} justifyItems={'center'}>
              <CheckedIconContainer />
              <Text>kabergolina</Text>
            </Grid>
            <Grid container display={'flex'} alignItems={'flex-start'}>
              {thirdStage.cabergolineDose > 0 && checkEmptyNumber(thirdStage.cabergolineDose) && (
                <Grid item xs={2.5} pr={2} alignSelf={'stretch'}>
                  <Input
                    disabled
                    variant={'standard'}
                    fullWidth={true}
                    name={'cabergolineDose'}
                    label={'Dawka (mg)'}
                    type={'number'}
                    value={checkEmptyNumber(thirdStage.cabergolineDose)}
                  />
                </Grid>
              )}
              {thirdStage.cabergolineDateStart && (
                <Grid item xs={2.5} pr={2} alignSelf={'stretch'}>
                  <Input
                    multiline
                    disabled
                    variant={'standard'}
                    fullWidth={true}
                    name={'cabergolineDateStart'}
                    label={'stosowanie - OD'}
                    type={'text'}
                    value={dateStringify(thirdStage.cabergolineDateStart, false)}
                  />
                </Grid>
              )}
              {thirdStage.cabergolineDateEnd && (
                <Grid item xs={2.5} alignSelf={'stretch'}>
                  <Input
                    multiline
                    disabled
                    variant={'standard'}
                    fullWidth={true}
                    name={'cabergolineDateEnd'}
                    label={'stosowanie - DO'}
                    type={'text'}
                    value={dateStringify(thirdStage.cabergolineDateEnd, false)}
                  />
                </Grid>
              )}
            </Grid>

            {thirdStage.cabergolineBiochemicalNormalization && (
              <Grid container display={'flex'} alignItems={'center'} mt={2}>
                <Grid item xs={12}>
                  <Typography variant={'subtitle1'}>Uzyskano normalizację biochemiczną:</Typography>
                </Grid>
                <Grid item xs={12} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                  <CheckedIconContainer />
                  <Text>{thirdStage.cabergolineBiochemicalNormalization}</Text>
                </Grid>
              </Grid>
            )}
            {thirdStage.cabergolineCortisolDzmisActive && (
              <Grid container>
                <Grid item xs={5} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                  <CheckedIconContainer />
                  <Text>wolnego kortyzolu w DZM</Text>
                </Grid>
                {thirdStage.cabergolineCortisolDzm && (
                  <Grid item xs={2.5} alignSelf={'stretch'}>
                    <Input
                      multiline
                      disabled
                      variant={'standard'}
                      fullWidth={true}
                      name={'cabergolineCortisolDzm'}
                      label={'okres - OD'}
                      type={'text'}
                      value={dateStringify(thirdStage.cabergolineCortisolDzm, false)}
                    />
                  </Grid>
                )}
              </Grid>
            )}
            {thirdStage.cabergolineCortisolSalivaisActive && (
              <Grid container>
                <Grid item xs={5} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                  <CheckedIconContainer />
                  <Text>wolnego kortyzolu w ślinie</Text>
                </Grid>
                {thirdStage.cabergolineCortisolSaliva && (
                  <Grid item xs={2.5} alignSelf={'stretch'}>
                    <Input
                      multiline
                      disabled
                      variant={'standard'}
                      fullWidth={true}
                      name={'cabergolineCortisolSaliva'}
                      label={'okres - OD'}
                      type={'text'}
                      value={dateStringify(thirdStage.cabergolineCortisolSaliva, false)}
                    />
                  </Grid>
                )}
              </Grid>
            )}
            {thirdStage.cabergolineCortisolSerumisActive && (
              <Grid container>
                <Grid item xs={5} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                  <CheckedIconContainer />
                  <Text>wolnego kortyzolu w surowicy</Text>
                </Grid>
                {thirdStage.cabergolineCortisolSerum && (
                  <Grid item xs={2.5} alignSelf={'stretch'}>
                    <Input
                      multiline
                      disabled
                      variant={'standard'}
                      fullWidth={true}
                      name={'cabergolineCortisolSerum'}
                      label={'okres - OD'}
                      type={'text'}
                      value={dateStringify(thirdStage.cabergolineCortisolSerum, false)}
                    />
                  </Grid>
                )}
              </Grid>
            )}

            {thirdStage.cabergolineToleranceOfPharmacologicalTreatment.length > 0 && (
              <Grid container display={'flex'} alignItems={'center'} mt={2}>
                <Grid item xs={12} mb={2}>
                  <Typography variant={'h6'}>Tolerancja stosowanego leczenia farmakologicznego:</Typography>
                </Grid>
                {thirdStage.cabergolineToleranceOfPharmacologicalTreatment.map(treatment => (
                    <Grid item key={treatment} xs={12} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                      <CheckedIconContainer />
                      <Text>{treatment}</Text>
                    </Grid>
                ))}
              </Grid>
            )}
            {thirdStage.cabergolineAnotherComplications && thirdStage.cabergolineAnotherComplications.length > 0 && (
              <Grid container display={'flex'} alignItems={'center'} mt={2} mb={2}>
                <Grid item xs={12} mb={2}>
                  <Typography variant={'h6'}>Inne powikłania:</Typography>
                </Grid>
                {thirdStage.cabergolineAnotherComplications.map(treatment => (
                    <Grid item key={treatment} xs={12} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                      <CheckedIconContainer />
                      <Text>{treatment}</Text>
                    </Grid>
                ))}
                {thirdStage.cabergolineAnotherComplicationsAnother && (
                  <>
                    <Grid item xs={3} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                      <CheckedIconContainer />
                      <Text>inne (jakie?)</Text>
                    </Grid>
                    <Grid item xs={9}>
                      <Input
                        multiline
                        disabled
                        variant={'standard'}
                        fullWidth={true}
                        name={'cabergolineAnotherComplicationsAnother'}
                        label={'inne (jakie?)'}
                        type={'text'}
                        value={thirdStage.cabergolineAnotherComplicationsAnother}
                      />
                    </Grid>
                  </>
                )}
              </Grid>
            )}
            {thirdStage.cabergolineReasonStopTreatment && (
              <Grid item xs={12}>
                <Input
                  multiline
                  disabled
                  variant={'standard'}
                  fullWidth={true}
                  name={'cabergolineReasonStopTreatment'}
                  label={'Powód przerwania leczenia (jeśli dotyczy)'}
                  type={'text'}
                  value={thirdStage.cabergolineReasonStopTreatment}
                />
              </Grid>
            )}
            <Grid item xs={12} my={4}>
              <Divider sx={{ width: '100%' }} />
            </Grid>
          </Grid>
        )}
      </>

      {thirdStage.steroidogenesisInhibitorCheckbox && (
        <>
          <Grid item xs={12} display={'flex'} alignItems={'center'} justifyItems={'center'}>
            <CheckedIconContainer />
            <Text>inhibitor steroidogenezy</Text>
          </Grid>
          <>
            {thirdStage.steroidogenesisInhibitorArray && thirdStage.steroidogenesisInhibitorArray.length > 0 && (
              <Grid container>
                {thirdStage.steroidogenesisInhibitorArray.map((el, index) => (
                  <Grid item xs={12} key={index} mb={2}>
                    <Grid item display="flex" gap={2} alignItems={'center'} justifyItems={'center'}>
                      <Grid>
                        <Typography variant={'subtitle1'}>{index + 1} Inhibitor:</Typography>
                      </Grid>
                      <Grid item display={'flex'} alignItems={'center'} justifyItems={'center'}>
                        <CheckedIconContainer />
                        <Text>{el.type}</Text>
                      </Grid>
                    </Grid>
                    {(el.type === 'Osilodrostat' || el.type === 'Metyrapon') && (
                      <>
                        <Grid item xs={12} gap={2} mt={1} display="flex">
                          {el.dose && (
                            <Grid item xs={6}>
                              <Input
                                disabled
                                variant={'standard'}
                                fullWidth={true}
                                name={'el.dose'}
                                label={'Dawka'}
                                type={'text'}
                                value={el.dose}
                              />
                            </Grid>
                          )}
                          {el.frequency && (
                            <Grid item xs={6}>
                              <Input
                                disabled
                                variant={'standard'}
                                fullWidth={true}
                                name={'cabergolineReasonStopTreatment'}
                                label={'ile razy na dobę'}
                                type={'text'}
                                value={el.frequency}
                              />
                            </Grid>
                          )}
                        </Grid>
                        {el.doseEscalation && (
                          <Grid item xs={12} mt={2}>
                            <Input
                              multiline
                              disabled
                              variant={'standard'}
                              fullWidth={true}
                              name={'cabergolineReasonStopTreatment'}
                              label={'W jaki sposób eskalowano dawkę?'}
                              type={'text'}
                              value={el.doseEscalation}
                            />
                          </Grid>
                        )}
                        <Grid container>
                          <Grid item xs={12} gap={2} mt={2} display="flex">
                            {el.maxDose && (
                              <Grid item xs={3}>
                                <Input
                                  disabled
                                  variant={'standard'}
                                  fullWidth={true}
                                  name={'el.dose'}
                                  label={'Dawka maksymalna'}
                                  type={'text'}
                                  value={el.maxDose}
                                />
                              </Grid>
                            )}

                            {el.maintenanceDose && (
                              <Grid item xs={3}>
                                <Input
                                  disabled
                                  variant={'standard'}
                                  fullWidth={true}
                                  name={'cabergolineReasonStopTreatment'}
                                  label={'Dawka podtrzymująca'}
                                  type={'text'}
                                  value={el.maintenanceDose}
                                />
                              </Grid>
                            )}
                            {el.dateStart && (
                              <Grid item xs={3}>
                                <Input
                                  disabled
                                  variant={'standard'}
                                  fullWidth={true}
                                  name={'cabergolineReasonStopTreatment'}
                                  label={'okres - OD'}
                                  type={'text'}
                                  value={dateStringify(el.dateStart, false)}
                                />
                              </Grid>
                            )}
                            {el.dateEnd && (
                              <Grid item xs={3}>
                                <Input
                                  disabled
                                  variant={'standard'}
                                  fullWidth={true}
                                  name={'cabergolineReasonStopTreatment'}
                                  label={'okres - DO'}
                                  type={'text'}
                                  value={dateStringify(el.dateEnd, false)}
                                />
                              </Grid>
                            )}
                          </Grid>
                        </Grid>
                      </>
                    )}
                    {el.type === 'Inny' && (
                      <>
                        <Grid container>
                          <Grid item xs={12} gap={2} mt={2} display="flex">
                            {el.name && (
                              <Grid item xs={3}>
                                <Input
                                  disabled
                                  variant={'standard'}
                                  fullWidth={true}
                                  name={'el.dose'}
                                  label={'Nazwa'}
                                  type={'text'}
                                  value={el.name}
                                />
                              </Grid>
                            )}

                            {el.dose && (
                              <Grid item xs={3}>
                                <Input
                                  disabled
                                  variant={'standard'}
                                  fullWidth={true}
                                  name={'cabergolineReasonStopTreatment'}
                                  label={'Dawka'}
                                  type={'text'}
                                  value={el.dose}
                                />
                              </Grid>
                            )}
                            {el.dateStart && (
                              <Grid item xs={3}>
                                <Input
                                  disabled
                                  variant={'standard'}
                                  fullWidth={true}
                                  name={'cabergolineReasonStopTreatment'}
                                  label={'okres - OD'}
                                  type={'text'}
                                  value={dateStringify(el.dateStart, false)}
                                />
                              </Grid>
                            )}
                            {el.dateEnd && (
                              <Grid item xs={3}>
                                <Input
                                  disabled
                                  variant={'standard'}
                                  fullWidth={true}
                                  name={'cabergolineReasonStopTreatment'}
                                  label={'okres - DO'}
                                  type={'text'}
                                  value={dateStringify(el.dateEnd, false)}
                                />
                              </Grid>
                            )}
                          </Grid>
                        </Grid>
                      </>
                    )}
                  </Grid>
                ))}
              </Grid>
            )}

            {thirdStage.biochemicalNormalization && (
              <Grid container display={'flex'} alignItems={'center'} mt={2}>
                <Grid item xs={12}>
                  <Typography variant={'subtitle1'}>Uzyskano normalizację biochemiczną:</Typography>
                </Grid>
                <Grid item xs={12} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                  <CheckedIconContainer />
                  <Text>{thirdStage.biochemicalNormalization}</Text>
                </Grid>
              </Grid>
            )}
            {thirdStage.steroidogenesisInhibitorDzmCheckbox && (
              <>
                <Grid item xs={12} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                  <CheckedIconContainer />
                  <Text>wolnego kortyzolu w DZM</Text>
                </Grid>
              </>
            )}
            {thirdStage.steroidogenesisInhibitorDzmArray?.length > 0 && (
              <CortisolChart
                leftLabelName="kortyzol w DZM"
                rightLabelName="dawka"
                data={thirdStage.steroidogenesisInhibitorDzmArray}
              />
            )}
            {thirdStage.steroidogenesisInhibitorSalivaCheckbox && (
              <>
                <Grid item xs={12} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                  <CheckedIconContainer />
                  <Text>wolnego kortyzolu w ślinie</Text>
                </Grid>
              </>
            )}
            {thirdStage.steroidogenesisInhibitorSalivaArray?.length > 0 && (
              <CortisolChart
                leftLabelName="kortyzol w ślinie"
                rightLabelName="dawka"
                data={thirdStage.steroidogenesisInhibitorSalivaArray}
              />
            )}
            {thirdStage.steroidogenesisInhibitorSerumCheckbox && (
              <Grid item xs={12} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                <CheckedIconContainer />
                <Text>kortyzolu w surowicy</Text>
              </Grid>
            )}
            {thirdStage.steroidogenesisInhibitorSerumArray?.length > 0 && (
              <CortisolChart
                leftLabelName="kortyzol w surowicy"
                rightLabelName="dawka"
                data={thirdStage.steroidogenesisInhibitorSerumArray}
              />
            )}

            {thirdStage.toleranceOfPharmacologicalTreatment &&
              thirdStage.toleranceOfPharmacologicalTreatment.length > 0 && (
                <>
                  <Grid item xs={12} mt={2}>
                    <Typography variant={'subtitle1'}>Tolerancja stosowanego leczenia farmakologicznego:</Typography>
                  </Grid>

                  {thirdStage.toleranceOfPharmacologicalTreatment.map((el, index) => (
                    <Grid item xs={12} key={index}>
                      <Grid item display={'flex'} alignItems={'center'} justifyItems={'center'}>
                        <CheckedIconContainer />
                        <Text>{el}</Text>
                      </Grid>
                    </Grid>
                  ))}
                </>
              )}

            {thirdStage.anotherComplications && thirdStage.anotherComplications.length > 0 && (
              <>
                <Grid item xs={12} mt={2}>
                  <Typography variant={'subtitle1'}>Inne powikłania:</Typography>
                </Grid>
                {thirdStage.anotherComplications.map((el, index) => (
                  <Grid item xs={12} key={index}>
                    <Grid item display={'flex'} alignItems={'center'} justifyItems={'center'}>
                      <CheckedIconContainer />
                      <Text>{el}</Text>
                    </Grid>
                  </Grid>
                ))}
              </>
            )}
            {thirdStage.anotherComplicationsAnother && thirdStage.anotherComplications?.includes('Inne') && (
              <Grid item xs={12}>
                <Input
                  disabled
                  variant={'standard'}
                  fullWidth={true}
                  name={'anotherComplicationsAnother'}
                  label={'Inne'}
                  type={'text'}
                  value={thirdStage.anotherComplicationsAnother}
                />
              </Grid>
            )}
            {thirdStage.reasonStopTreatment && (
              <Grid item xs={12} mt={2}>
                <Input
                  disabled
                  variant={'standard'}
                  fullWidth={true}
                  name={'reasonStopTreatment'}
                  label={'Powód przerwania leczenia (jeśli dotyczy)'}
                  type={'text'}
                  value={thirdStage.reasonStopTreatment}
                />
              </Grid>
            )}
          </>
        </>
      )}
      {thirdStage.qualificationsDiagnosis && thirdStage.qualificationsDiagnosis?.length > 0 && (
        <Grid container>
          <Grid item xs={12} mt={4} mb={2}>
            <Typography variant={'h6'}>Kwalifikacja do:</Typography>
          </Grid>
          {thirdStage.qualificationsDiagnosisAccess && (
            <>
              <Grid item xs={6} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                <CheckedIconContainer />
                <Text>ponownego leczenia neurochirurgicznego</Text>
              </Grid>
              <Grid item xs={6} pl={2} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                <Input
                  disabled
                  variant={'standard'}
                  fullWidth={true}
                  name={'qualificationsDiagnosisAccess'}
                  label={'Z jakiego dostępu'}
                  type={'text'}
                  value={thirdStage.qualificationsDiagnosisAccess}
                />
              </Grid>
            </>
          )}

          {thirdStage.qualificationsDiagnosis.map(qualification => (
            <Grid key={qualification} item xs={12} display={'flex'} alignItems={'center'} justifyItems={'center'}>
              <CheckedIconContainer />
              <Text>{qualification}</Text>
            </Grid>
          ))}
        </Grid>
      )}
      {thirdStage.supprotiveTreatment.length > 0 && (
        <Grid container display={'flex'} alignItems={'center'} mt={2}>
          <Grid item xs={12} mt={2} mb={4}>
            <Typography variant={'h6'}>Leczenie wspomagające chorób współistniejących i powikłań:</Typography>
          </Grid>
          {thirdStage.supprotiveTreatment.map((treatment, index) => (
            <Grid container key={treatment.drug + index} display={'flex'} alignItems={'center'} mb={2}>
              <Grid item xs={0.5} pl={2}>
                <Text>{index + 1}</Text>
              </Grid>
              <Grid item xs={3} pr={2} pl={2} alignSelf={'stretch'}>
                <Input
                  multiline
                  disabled
                  variant={'standard'}
                  fullWidth={true}
                  name={'treatment.group'}
                  label={'Grupa leków'}
                  type={'text'}
                  value={treatment.group}
                />
              </Grid>
              <Grid item xs={3} pr={2} alignSelf={'stretch'}>
                <Input
                  multiline
                  disabled
                  variant={'standard'}
                  fullWidth={true}
                  name={'treatment.drug'}
                  label={'Lek'}
                  type={'text'}
                  value={treatment.drug}
                />
              </Grid>
              <Grid item xs={3} alignSelf={'stretch'}>
                <Input
                  multiline
                  disabled
                  variant={'standard'}
                  fullWidth={true}
                  name={'treatment.dose'}
                  label={'Dawka'}
                  type={'text'}
                  value={treatment.dose}
                />
              </Grid>
            </Grid>
          ))}
        </Grid>
      )}
      {thirdStage.improvementControl.length > 0 && (
        <Grid container display={'flex'} alignItems={'center'} mt={2}>
          <Grid item xs={12} mb={2}>
            <Typography variant={'h6'}>Uzyskano poprawę w zakresie:</Typography>
          </Grid>
          {thirdStage.improvementControl.map(improvementControlElement => (
              <Grid
                item
                key={improvementControlElement}
                xs={12}
                display={'flex'}
                alignItems={'center'}
                justifyItems={'center'}
              >
                <CheckedIconContainer />
                <Text>{improvementControlElement}</Text>
              </Grid>
          ))}
        </Grid>
      )}
    </Grid>
  );
});
